<template lang="pug">
el-container.main
    .main-content
        el-table(
            :data="items",
            :stripe="true",
            border,
            max-height="640",
            style="width: 100%",
            :header-cell-style="tableHeaderColor"
        )
            el-table-column(prop="name", label="供应商", width="500")
            el-table-column(prop="satellites", label="已接收卫星个数", width="120")
                template(slot-scope="scope")
                    el-popover(placement="bottom", trigger="hover")
                        div
                            el-tag(v-for="(sat, index) in scope.row.satellites", :key="inde") {{ sat.satellite_CosparNum }}
                        el-button(slot="reference", type="text") {{ scope.row.satellites.length }}
            el-table-column(prop="comments", label="备注")
            el-table-column(label="操作")
                template(slot-scope="scope")
                    el-button(type="text", @click="handleEditClick(scope.row.id)") 编辑
                    el-button(type="text")
                        a(:href="scope.row.website", target="__blank") 官网

            el-dialog(title="编辑供应商", :visible.sync="dialogFormVisible")
                el-form(:model="editItem")
                    el-form-item(label="名称", label-width="80px")
                        el-input(v-model="editItem.name", autocomplete="off")
                    el-form-item(label="网址", label-width="80px")
                        el-input(v-model="editItem.website", autocomplete="off")
                    el-form-item(label="备注", label-width="80px")
                        el-input(v-model="editItem.comments", type="textarea", autosize)
                .dialog-footer(slot="footer")
                    el-button(@click="handleCancelClick") 取 消
                    el-button(type="primary", @click="handleConfirmClick") 确 定

    .main-pager
        el-pagination.page(
            @size-change="handleSizeChange",
            @prev-click="handlePrevClick",
            @next-click="handleNextClick",
            @current-change="handleCurrentChange",
            :current-page.sync="pagination.currentPage",
            :page-sizes="[10, 20, 50]",
            :page-size="10",
            layout="total, sizes, prev, next, jumper",
            :total="pagination.total"
        )
</template>

<script>
// @ is an alias to /src
import { listDataVendor, getDataVendor } from "@/services";

export default {
    name: "data-vendor",
    data() {
        return {
            loading: false,
            items: [],
            pagination: {
                total: 1,
                currentPage: 1,
                pageSize: 10,
                offset: 0,
            },
            dialogFormVisible: false,
            editItem: {
                name: "",
                website: "",
                comments: "",
            },
        };
    },
    methods: {
        async fetch() {
            this.loading = true;
            const res = await listDataVendor({
                limit: this.pagination.pageSize,
                offset: this.pagination.offset,
            });
            if (res.status === 200) {
                this.items = res.data.results;
                this.pagination.total = res.data.count;
            } else {
                console.log("request data vendors failed");
            }
            this.loading = false;
        },
        async getDataVendorDetail(val) {
            const res = await getDataVendor({ id: val });
            if (res.status === 200) {
                this.editItem = res.data;
            } else {
                console.log("request data vendor failed");
            }
        },
        handleEditClick(val) {
            this.dialogFormVisible = true;
            this.getDataVendorDetail(val);
        },
        handleCancelClick() {
            this.dialogFormVisible = false;
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.fetch();
        },
        handleCurrentChange(val) {
            this.pagination.offset = (val - 1) * this.pagination.pageSize;
            this.fetch();
        },
        handlePrevClick(val) {
            this.pagination.offset = (val - 1) * this.pagination.pageSize;
            this.fetch();
        },
        handleNextClick(val) {
            this.pagination.offset = (val - 1) * this.pagination.pageSize;
            this.fetch();
        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color: #f2f2f2;color: #8493A8;";
            }
        },
    },
    mounted() {
        this.fetch();
    },
};
</script>
